import { terraContract } from '@terra/shared-authorization';
import {
  TenantIpAllowlistStateSchema,
  UpdateTenantIpAllowlistSchema,
} from '@terra/shared-contracts-tenant-settings';
import { ToolExecutionHarSchema } from '@terra/shared-contracts-tracker';
import {
  TriggerExternalNetworkFindingChainingReplayRequestSchema,
  TriggerFindingChainingReplayRequestSchema,
  TriggerFindingChainingReplayResponseSchema,
} from './finding-chaining-replay.schema';
import {
  DashboardKpiSchema,
  TenantSummarySchema,
  TenantHealthSchema,
  CustomerHealthQuerySchema,
  CustomerHealthResponseSchema,
  TenantHealthDetailSchema,
  ExecutionStatsSchema,
  SignalDistributionSchema,
  SignalCategoryDistributionSchema,
  SignalStatusDistributionSchema,
  FindingsStatsSchema,
  TenantFindingsByAgeSchema,
  AttackSurfaceFunnelSchema,
  TenantTrendSchema,
  ExportRequestSchema,
  DateRangeQuerySchema,
  TenantFilterQuerySchema,
  TenantMetricsFilterQuerySchema,
  TraceListItemSchema,
  TraceListQuerySchema,
  TraceStatusCountsSchema,
  TraceDetailSchema,
  ApplicationLookupItemSchema,
  FeatureFlagItemSchema,
  FeatureFlagDetailSchema,
  UpdateFeatureFlagBodySchema,
  CostLicenseTypeOverviewSchema,
  CostOverviewSchema,
  CostQuerySchema,
  CostByThreadQuerySchema,
  CostBreakdownItemSchema,
  CostFlowSankeySchema,
  CostThreadSummarySchema,
  CostByApplicationCategorySchema,
  AnalyticsQuerySchema,
  FindingsAnalyticsQuerySchema,
  FindingsTrendsQuerySchema,
  AutoPublishedFindingOutcomesQuerySchema,
  AutoPublishedFindingOutcomesSchema,
  AutoFpRateQuerySchema,
  AutoFpRateSchema,
  AutoFpRateSignalsQuerySchema,
  AutoFpSignalRowsPageSchema,
  MatchedRuleAnalyticsQuerySchema,
  MatchedRuleAnalyticsSchema,
  SignalPrecisionQuerySchema,
  SignalPrecisionSignalsQuerySchema,
  SignalPrecisionSchema,
  SignalAnalyticsSchema,
  FindingAnalyticsSchema,
  ExecutionAnalyticsSchema,
  GitOverviewSchema,
  GitQuerySchema,
  TechnologyUsageQuerySchema,
  TechnologyUsageSchema,
  CrawlerOverviewSchema,
  CrawlerQuerySchema,
  TriggerCrawlerRequestSchema,
  TriggerCrawlerResponseSchema,
  TriggerAuthenticationDiscoveryBodySchema,
  TriggerAuthenticationDiscoveryResponseSchema,
  EndpointHealthOverviewSchema,
  EndpointHealthQuerySchema,
  TriggerCodeGraphRequestSchema,
  TriggerMissingCodeGraphsRequestSchema,
  ResetFailedGraphsRequestSchema,
  TriggerStupidSignalsRequestSchema,
  TriggerDeepActiveProbeAllRequestSchema,
  TriggerDeepActiveProbeAllResponseSchema,
  DeepActiveProbePauseStatusSchema,
  SetDeepActiveProbePauseRequestSchema,
  TriggerSmartSignalsRequestSchema,
  TriggerAiSignalGenerationRequestSchema,
  SmartSignalActionResponseSchema,
  EndpointActionResponseSchema,
  AllEndpointsQuerySchema,
  AllEndpointsResponseSchema,
  StartEndpointBulkRunRequestSchema,
  EndpointBulkRunSchema,
  EndpointBulkRunParamsSchema,
  ActiveEndpointBulkRunQuerySchema,
  ActiveEndpointBulkRunResponseSchema,
  DismissEndpointBulkRunResponseSchema,
  DeduplicateSignalsBulkRequestSchema,
  DeduplicateSignalsBulkResponseSchema,
  ContentFilterListQuerySchema,
  ContentFilterListItemSchema,
  ContentFilterDetailSchema,
  ContentFilterAnalyticsQuerySchema,
  ContentFilterAnalyticsSchema,
  EndpointSourceCoverageQuerySchema,
  EndpointSourceCoverageOverviewSchema,
  CreatePovEnvironmentBodySchema,
  PovEnvironmentStatusResponseSchema,
  PovEnvironmentListResponseSchema,
  PovEnvironmentListQuerySchema,
  ExtendPovEnvironmentBodySchema,
  UpdatePovEnvironmentIngressBodySchema,
  DestroyPovEnvironmentBodySchema,
  DestroyPovEnvironmentResponseSchema,
  CockpitAuditLogsQuerySchema,
  CockpitAuditLogsResponseSchema,
  CockpitAuditLogFiltersQuerySchema,
  CockpitAuditLogFiltersResponseSchema,
  CockpitUsersResponseSchema,
  K8sOperatorsResponseSchema,
  CreateK8sOperatorBodySchema,
  CreateK8sOperatorResponseSchema,
  RotateK8sOperatorAccessKeyResponseSchema,
  K8sOperatorDetailResponseSchema,
  DeleteK8sOperatorResponseSchema,
  GetK8sOperatorActivityResponseSchema,
  GetK8sOperatorExecutionsResponseSchema,
  GetK8sOperatorHelmReleasesQuerySchema,
  GetK8sOperatorHelmReleasesResponseSchema,
  RequestK8sOperatorHelmListBodySchema,
  RequestK8sOperatorHelmListResponseSchema,
  PublishK8sOperatorManifestBodySchema,
  PublishK8sOperatorManifestResponseSchema,
  PublishK8sOperatorKubectlBodySchema,
  PublishK8sOperatorHelmCommandBodySchema,
  PublishK8sOperatorHelmCommandResponseSchema,
  PublishK8sOperatorHelmUpgradeBodySchema,
  PublishK8sOperatorKubectlResponseSchema,
  PublishK8sOperatorHelmReleaseResponseSchema,
  PublishK8sOperatorMessageBodySchema,
  PublishK8sOperatorMessageResponseSchema,
  UpdateK8sOperatorHelmReleaseBodySchema,
  UpdateK8sOperatorHelmReleaseResponseSchema,
  CreateTenantBodySchema,
  CreateTenantResponseSchema,
  SubtenantParentTenantsResponseSchema,
  TenantPickerQuerySchema,
  UpdateTenantConfigSchema,
  ProvisionCompanyBodySchema,
  ProvisionCompanyResponseSchema,
  DeleteTenantDataQuerySchema,
  DeleteTenantDataResponseSchema,
  AppNotesSchema,
  AppCommentSchema,
  UpdateAppStatusBodySchema,
  UpdateAppDescriptionBodySchema,
  UpdateAppResearcherBodySchema,
  UpdateAppTorchEnabledBodySchema,
  AppTorchEnabledResponseSchema,
  CreateAppCommentBodySchema,
  AppsStatusesSchema,
  TenantAppSubitemsSchema,
  AppsOverviewQuerySchema,
  AppsOverviewSchema,
  TriggerCodeGraphBulkRequestSchema,
  EndpointMissingCodeGraphQuerySchema,
  EndpointMissingCodeGraphListSchema,
  CoPilotSkillsCatalogSchema,
  CoPilotCustomSkillsQuerySchema,
  CoPilotCustomSkillsResponseSchema,
  CoPilotCustomSkillResponseSchema,
  CopilotThreadFilesystemResponseSchema,
  CopilotThreadFilesystemQuerySchema,
  FpAnalyticsQuerySchema,
  FpAnalyticsSchema,
  FpFeedbackQuerySchema,
  FpFeedbackPageSchema,
  FnAnalyticsQuerySchema,
  FnAnalyticsSchema,
  FnListQuerySchema,
  FnPageSchema,
  CoPilotEvalScenarioSchema,
  CoPilotEvalRunSchema,
  CoPilotEvalDashboardSchema,
  CreateCoPilotEvalScenarioBodySchema,
  ImportCoPilotEvalScenariosBodySchema,
  ImportCoPilotEvalScenariosResultSchema,
  DraftCoPilotEvalScenarioBodySchema,
  CoPilotEvalScenarioDraftSchema,
  ParseCoPilotEvalScenariosCsvBodySchema,
  ParseCoPilotEvalScenariosCsvResultSchema,
  ImportCoPilotEvalScenariosFromDraftsBodySchema,
  TriggerCoPilotEvalRunBodySchema,
  BulkTriggerCoPilotEvalRunBodySchema,
  BatchTriggerCoPilotEvalRunBodySchema,
  CreateCoPilotEvalExperimentBodySchema,
  CoPilotEvalExperimentSchema,
  CoPilotEvalExperimentStatsSchema,
  CoPilotEvalScenarioStatsSchema,
  CoPilotEvalBatchStatsSchema,
  CoPilotEvalDatasetSchema,
  CreateCoPilotEvalDatasetBodySchema,
  UpdateCoPilotEvalDatasetBodySchema,
  ImportCoPilotEvalDatasetCsvBodySchema,
  ImportCoPilotEvalDatasetCsvAiBodySchema,
  ImportCoPilotEvalDatasetCsvResultSchema,
  CoPilotEvalDatasetExperimentSchema,
  CreateCoPilotEvalDatasetExperimentBodySchema,
  CoPilotEvalDatasetExperimentStatsSchema,
  CoPilotEvalDatasetExperimentDetailSchema,
  CoPilotEvalDatasetExperimentMetaAnalysisResponseSchema,
  CoPilotEvalDatasetExperimentMetaAnalysisGenerateResponseSchema,
  CoPilotRunModelsSchema,
  ResolveCoPilotAgentModelsBodySchema,
  CoPilotAgentModelsConfigSchema,
  ExportCoPilotEvalRunsQuerySchema,
  FpReportsListSchema,
  FpReportListQuerySchema,
  FpReportQuerySchema,
  FpReportContentSchema,
  FpRecommendationReportsListSchema,
  FpRecommendationsQuerySchema,
  FpRecommendationsContentSchema,
  BusinessContextCapabilityOverviewQuerySchema,
  BusinessContextCapabilityOverviewSchema,
  BusinessContextCapabilityDetailSchema,
} from './cockpit.schemas';
import { AiCacheOverviewSchema, AiCacheQuerySchema } from './ai-cache.schemas';
import {
  ProvisionAigbankApplicationBodySchema,
  ProvisionAigbankApplicationResponseSchema,
} from './aigbank-application-provision.schemas';
import {
  CoPilotVisibilityQuerySchema,
  CoPilotVisibilityKpiSchema,
  CoPilotVisibilityCostSchema,
  CoPilotExpensiveTraceSchema,
  CoPilotExpensiveTraceDetailSchema,
  CoPilotVisibilityErrorsSchema,
  CoPilotVisibilityQueriesSchema,
  CoPilotVisibilityCategoryQueriesQuerySchema,
  CoPilotVisibilityCategoryQueriesSchema,
  CoPilotVisibilityPerformanceSchema,
  CoPilotFeedbackInvestigationsQuerySchema,
  CoPilotFeedbackInvestigationRowSchema,
  CoPilotFeedbackInvestigationDetailSchema,
} from './copilot-visibility.schemas';
import {
  LicenseResponseSchema,
  UpsertLicenseBodySchema,
} from './license.schemas';
import {
  PT_LEADERBOARD_READER_PERMISSION,
  PtLeaderboardQuerySchema,
  PtLeaderboardResponseSchema,
} from './pt-leaderboard.schemas';
import { z } from 'zod';
import { cockpitPublicRoutes } from './cockpit.public.contract';
import { cockpitSystemRoutes } from './cockpit-system.contract';
import { cockpitBillingRoutes } from './cockpit-billing.contract';
import { cockpitMisconfigResearchRoutes } from './cockpit-misconfig-research.contract';
import { cockpitValidationHubRoutes } from './cockpit-validation-hub.contract';
import { cockpitTenantModelRouterRoutes } from './cockpit-tenant-model-router.contract';
import { cockpitAiAccountRoutes } from './cockpit-ai-accounts.contract';
import { cockpitEvaluationRoutes } from './cockpit.evaluation.routes';
import { cockpitSqlWorksheetRoutes } from './sql-worksheet.contract';
import { cockpitMemoryRoutes } from './cockpit-memory.contract';
import {
  COCKPIT_ADMIN_PERMISSION,
  COCKPIT_APP_DUPLICATOR_PERMISSIONS,
  COCKPIT_ENDPOINT_OPS_PERMISSIONS,
  COCKPIT_FEATURE_FLAG_WRITE_PERMISSIONS,
  COCKPIT_LICENSE_WRITE_PERMISSIONS,
} from './cockpit-permissions';
import {
  AddTenantAdminsBodySchema,
  AddTenantAdminsResponseSchema,
} from './cockpit-tenant-admins.schema';
import {
  ApplicationDuplicationJobParamsSchema,
  ApplicationDuplicationJobSchema,
  StartApplicationDuplicationJobRequestSchema,
  StartApplicationDuplicationJobResponseSchema,
} from './application-duplication.schemas';

const AIGBANK_POV_CREATE_PERMISSIONS = [
  COCKPIT_ADMIN_PERMISSION,
  'Cockpit Power User',
] as const;

const PT_LEADERBOARD_READER_PERMISSIONS = [
  PT_LEADERBOARD_READER_PERMISSION,
] as const;
const AIGBANK_POV_READ_PERMISSIONS = [
  COCKPIT_ADMIN_PERMISSION,
  'Cockpit Power User',
] as const;
const AIGBANK_POV_LIFECYCLE_PERMISSIONS = [
  COCKPIT_ADMIN_PERMISSION,
  'Cockpit Power User',
] as const;

export const cockpitContract = terraContract.router({
  getDashboardKpis: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/dashboard',
      summary: 'Get cross-tenant dashboard KPIs',
      inputStructure: 'detailed',
    })
    .output(DashboardKpiSchema),
  getTenantsOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants',
      summary: 'List all tenants with summary stats',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: TenantFilterQuerySchema }))
    .output(
      z.object({
        tenants: z.array(TenantSummarySchema),
        total: z.number(),
      }),
    ),
  listTenantsForPicker: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/picker',
      summary: 'List tenants for Cockpit pickers',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: TenantPickerQuerySchema }))
    .output(SubtenantParentTenantsResponseSchema),
  listSubtenantParentTenants: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'GET',
      path: '/tenants/subtenant-parents',
      summary: 'List root-level Descope tenants eligible as sub-tenant parents',
      inputStructure: 'detailed',
    })
    .output(SubtenantParentTenantsResponseSchema),
  createTenant: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/tenants',
      summary:
        'Create a new tenant in Descope (root or sub-tenant under a selected root parent)',
      inputStructure: 'detailed',
      successStatus: 201,
    })
    .input(z.object({ body: CreateTenantBodySchema }))
    .output(CreateTenantResponseSchema),
  addTenantAdmins: terraContract
    .meta({ permissions: [COCKPIT_ADMIN_PERMISSION] })
    .route({
      method: 'POST',
      path: '/tenants/{tenantId}/admins',
      summary: 'Add product Tenant Admins to a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string().min(1) }),
        body: AddTenantAdminsBodySchema,
      }),
    )
    .output(AddTenantAdminsResponseSchema),
  getTenantDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}',
      summary: 'Get single tenant detail',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(TenantSummarySchema),
  updateTenantConfig: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PATCH',
      path: '/tenants/{tenantId}/config',
      summary: 'Update tenant config (customer status, tenant status)',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        body: UpdateTenantConfigSchema,
      }),
    )
    .output(z.object({ success: z.boolean() })),
  getTenantIpAllowlist: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/ip-allowlist',
      summary: 'Get a tenant IP allowlist',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string().min(1) }) }))
    .output(
      z.object({
        allowlist: TenantIpAllowlistStateSchema,
        featureEnabled: z.boolean(),
      }),
    ),
  updateTenantIpAllowlist: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PUT',
      path: '/tenants/{tenantId}/ip-allowlist',
      summary: 'Replace a tenant IP allowlist',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string().min(1) }),
        body: UpdateTenantIpAllowlistSchema,
      }),
    )
    .output(TenantIpAllowlistStateSchema),
  clearTenantIpAllowlist: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'DELETE',
      path: '/tenants/{tenantId}/ip-allowlist',
      summary: 'Remove a tenant IP allowlist',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string().min(1) }) }))
    .output(TenantIpAllowlistStateSchema),
  provisionCompany: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/tenants/{tenantId}/provision-company',
      summary: 'Trigger async company profile provisioning for a tenant',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        body: ProvisionCompanyBodySchema,
      }),
    )
    .output(ProvisionCompanyResponseSchema),
  deleteTenantData: terraContract
    .meta({ permissions: [COCKPIT_ADMIN_PERMISSION] })
    .route({
      method: 'DELETE',
      path: '/tenants/{tenantId}/data',
      summary:
        'Delete all data for a tenant across every service, optionally scoped to a single application',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: DeleteTenantDataQuerySchema,
      }),
    )
    .output(DeleteTenantDataResponseSchema),
  getAppNotes: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/apps/{applicationId}/notes',
      summary: 'Get status and comments for an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
      }),
    )
    .output(AppNotesSchema),
  triggerAuthenticationDiscovery: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/applications/{applicationId}/authentication-discovery',
      summary: 'Trigger authentication discovery for an application credential',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(
      z.object({
        params: z.object({ applicationId: z.string().min(1) }),
        body: TriggerAuthenticationDiscoveryBodySchema,
      }),
    )
    .output(TriggerAuthenticationDiscoveryResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
      BAD_REQUEST: { status: 400, data: z.object({ message: z.string() }) },
    }),
  triggerAuthenticationScriptGeneration: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/applications/{applicationId}/authentication-discovery/generate-script',
      summary:
        'Trigger login script generation from cached HAR analysis for an application credential',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(
      z.object({
        params: z.object({ applicationId: z.string().min(1) }),
        body: TriggerAuthenticationDiscoveryBodySchema,
      }),
    )
    .output(TriggerAuthenticationDiscoveryResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
      BAD_REQUEST: { status: 400, data: z.object({ message: z.string() }) },
    }),
  triggerAuthenticationScriptValidation: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/applications/{applicationId}/authentication-discovery/validate-script',
      summary:
        'Trigger stored login script validation for an application credential',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(
      z.object({
        params: z.object({ applicationId: z.string().min(1) }),
        body: TriggerAuthenticationDiscoveryBodySchema,
      }),
    )
    .output(TriggerAuthenticationDiscoveryResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
      BAD_REQUEST: { status: 400, data: z.object({ message: z.string() }) },
    }),
  updateAppStatus: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PATCH',
      path: '/tenants/{tenantId}/apps/{applicationId}/status',
      summary: 'Update the operational status of an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
        body: UpdateAppStatusBodySchema,
      }),
    )
    .output(z.object({ success: z.boolean() })),
  updateAppDescription: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PATCH',
      path: '/tenants/{tenantId}/apps/{applicationId}/description',
      summary: 'Update the operational description of an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
        body: UpdateAppDescriptionBodySchema,
      }),
    )
    .output(z.object({ success: z.boolean() })),
  updateAppResearcher: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PATCH',
      path: '/tenants/{tenantId}/apps/{applicationId}/researcher',
      summary: 'Update the assigned researcher of an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
        body: UpdateAppResearcherBodySchema,
      }),
    )
    .output(z.object({ success: z.boolean() })),
  updateAppTorchEnabled: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PATCH',
      path: '/tenants/{tenantId}/apps/{applicationId}/torch-enabled',
      summary: 'Update per-application Torch access override',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
        body: UpdateAppTorchEnabledBodySchema,
      }),
    )
    .output(AppTorchEnabledResponseSchema),
  addAppComment: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/tenants/{tenantId}/apps/{applicationId}/comments',
      summary: 'Add a comment to an application',
      inputStructure: 'detailed',
      successStatus: 201,
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
        body: CreateAppCommentBodySchema,
      }),
    )
    .output(AppCommentSchema),
  getAppsStatuses: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/apps/statuses',
      summary: 'Get all app statuses for a tenant',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(AppsStatusesSchema),
  getTenantAppSubitems: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/apps/subitems',
      summary:
        'List a tenant applications with operational status and description',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(TenantAppSubitemsSchema),
  getTenantExecutionStats: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/executions',
      summary: 'Get execution stats for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: DateRangeQuerySchema.extend({
          applicationId: z.string().optional(),
        }),
      }),
    )
    .output(ExecutionStatsSchema),
  getTenantSignalDistribution: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/signals',
      summary: 'Get signal distribution for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: DateRangeQuerySchema.extend({
          applicationId: z.string().optional(),
          category: z.string().optional(),
          status: z.string().optional(),
          stage: z.string().optional(),
          restrictToCategoriesInScope: z.preprocess((val) => {
            if (val === true || val === 'true') {
              return true;
            }

            if (val === false || val === 'false') {
              return false;
            }

            if (val === undefined || val === null || val === '') {
              return undefined;
            }

            return val;
          }, z.boolean().optional()),
        }),
      }),
    )
    .output(SignalDistributionSchema),
  getTenantSignalCategoryDistribution: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/signals/by-category',
      summary: 'Get signal distribution grouped by category for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: DateRangeQuerySchema.extend({
          applicationId: z.string().optional(),
        }),
      }),
    )
    .output(SignalCategoryDistributionSchema),
  getTenantSignalStatusDistribution: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/signals/by-status',
      summary: 'Get signal distribution grouped by status for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: DateRangeQuerySchema.extend({
          applicationId: z.string().optional(),
          category: z.string().optional(),
          status: z.string().optional(),
          stage: z.string().optional(),
        }),
      }),
    )
    .output(SignalStatusDistributionSchema),
  getTenantFindingsStats: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/findings',
      summary: 'Get findings stats for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: DateRangeQuerySchema.extend({
          applicationId: z.string().optional(),
          status: z.string().optional(),
          category: z.string().optional(),
          isPublished: z.preprocess((val) => {
            if (val === true || val === 'true') {
              return true;
            }

            if (val === false || val === 'false') {
              return false;
            }

            if (val === undefined || val === null || val === '') {
              return undefined;
            }

            return val;
          }, z.boolean().optional()),
        }),
      }),
    )
    .output(FindingsStatsSchema),
  getTenantFindingsByAge: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/findings/by-age',
      summary: 'Get open findings grouped by age buckets for a tenant',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(TenantFindingsByAgeSchema),
  getExecutionTrends: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/executions/trends',
      summary: 'Get execution trends across tenants',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: DateRangeQuerySchema }))
    .output(z.array(TenantTrendSchema)),
  getSignalTrends: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/signals/trends',
      summary: 'Get signal trends across tenants',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: DateRangeQuerySchema }))
    .output(z.array(TenantTrendSchema)),
  getFindingsTrends: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/findings/trends',
      summary: 'Get findings trends across tenants',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FindingsTrendsQuerySchema }))
    .output(z.array(TenantTrendSchema)),
  triggerFindingChainingReplay: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/findings/trigger-chaining-replay',
      summary:
        'Re-publish FINDING_PUBLISHED_EVENT for recent published findings (configurable limit)',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerFindingChainingReplayRequestSchema }))
    .output(TriggerFindingChainingReplayResponseSchema),
  triggerExternalNetworkFindingChainingReplay: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/findings/trigger-external-network-chaining-replay',
      summary:
        'Re-publish FINDING_PUBLISHED_EVENT for recent published external-network findings (configurable limit)',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        body: TriggerExternalNetworkFindingChainingReplayRequestSchema,
      }),
    )
    .output(TriggerFindingChainingReplayResponseSchema),
  getCustomerHealth: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/customer-health',
      summary:
        'Get active-customer human-queue totals and per-app signal status rows',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CustomerHealthQuerySchema }))
    .output(CustomerHealthResponseSchema),
  getCustomerHealthDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/customer-health/{tenantId}',
      summary: 'Get detailed health for a tenant',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(TenantHealthSchema),
  getTenantAppsHealth: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/apps-health',
      summary: 'Get per-application health status for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        query: TenantMetricsFilterQuerySchema,
      }),
    )
    .output(TenantHealthDetailSchema),
  getAppsOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/apps',
      summary: 'List all applications across tenants with health data',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AppsOverviewQuerySchema }))
    .output(AppsOverviewSchema),
  listApplications: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/applications',
      summary: 'List all applications for name resolution',
      inputStructure: 'detailed',
    })
    .output(
      z.object({
        applications: z.array(ApplicationLookupItemSchema),
      }),
    ),
  listTraces: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/traces',
      summary: 'List individual traces across all tenants',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: TraceListQuerySchema }))
    .output(
      z.object({
        traces: z.array(TraceListItemSchema),
        total: z.number(),
        statusCounts: TraceStatusCountsSchema.optional(),
      }),
    ),
  getTraceDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/traces/{threadId}',
      summary: 'Get full thread detail with messages and files',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ threadId: z.string() }) }))
    .output(TraceDetailSchema),
  listToolExecutionHarsByIds: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'POST',
      path: '/tool-execution-hars/by-ids',
      summary: 'Get tool execution HAR records by id',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        body: z.object({
          ids: z.array(z.string().min(1)).min(1).max(50),
        }),
      }),
    )
    .output(
      z.object({
        hars: z.array(ToolExecutionHarSchema),
      }),
    ),
  exportData: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/export',
      summary: 'Export data for POV',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ExportRequestSchema }))
    .output(z.record(z.string(), z.array(z.record(z.string(), z.unknown())))),
  createPovEnvironment: terraContract
    .meta({ permissions: [...AIGBANK_POV_CREATE_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/pov/environments',
      summary: 'Create a new AIGBank POV environment',
      inputStructure: 'detailed',
      successStatus: 201,
    })
    .input(z.object({ body: CreatePovEnvironmentBodySchema }))
    .output(PovEnvironmentStatusResponseSchema),
  listPovEnvironments: terraContract
    .meta({ permissions: [...AIGBANK_POV_READ_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/pov/environments',
      summary: 'List AIGBank POV environments',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: PovEnvironmentListQuerySchema }))
    .output(PovEnvironmentListResponseSchema),
  getPovEnvironmentStatus: terraContract
    .meta({ permissions: [...AIGBANK_POV_READ_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/pov/environments/{environmentId}',
      summary: 'Get AIGBank POV environment status and execution steps',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ environmentId: z.string() }) }))
    .output(PovEnvironmentStatusResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  destroyPovEnvironment: terraContract
    .meta({ permissions: [...AIGBANK_POV_LIFECYCLE_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/pov/environments/{environmentId}/destroy',
      summary: 'Destroy an AIGBank POV environment',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ environmentId: z.string() }),
        body: DestroyPovEnvironmentBodySchema.optional(),
      }),
    )
    .output(DestroyPovEnvironmentResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  extendPovEnvironment: terraContract
    .meta({ permissions: [...AIGBANK_POV_LIFECYCLE_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/pov/environments/{environmentId}/extend',
      summary: 'Extend TTL for an AIGBank POV environment',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ environmentId: z.string() }),
        body: ExtendPovEnvironmentBodySchema,
      }),
    )
    .output(PovEnvironmentStatusResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  updatePovEnvironmentIngress: terraContract
    .meta({ permissions: [...AIGBANK_POV_LIFECYCLE_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/pov/environments/{environmentId}/ingress',
      summary: 'Update extra inbound CIDR rules for an AIGBank POV environment',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ environmentId: z.string() }),
        body: UpdatePovEnvironmentIngressBodySchema,
      }),
    )
    .output(PovEnvironmentStatusResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  resetPovEnvironmentDatabase: terraContract
    .meta({ permissions: [...AIGBANK_POV_LIFECYCLE_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/pov/environments/{environmentId}/reset-db',
      summary:
        'Reset the AIGBank POV database by cleaning Docker volumes and restarting containers',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ environmentId: z.string() }) }))
    .output(PovEnvironmentStatusResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  provisionAigbankApplication: terraContract
    .meta({ permissions: [COCKPIT_ADMIN_PERMISSION] })
    .route({
      method: 'POST',
      path: '/pov/aigbank-applications',
      summary:
        'Provision a Terra AIG Bank application for a tenant (academy pack or AI code analysis pipeline)',
      inputStructure: 'detailed',
      successStatus: 201,
    })
    .input(z.object({ body: ProvisionAigbankApplicationBodySchema }))
    .output(ProvisionAigbankApplicationResponseSchema),
  listFeatureFlags: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/feature-flags',
      summary: 'List all feature flags with override counts',
      inputStructure: 'detailed',
    })
    .output(z.array(FeatureFlagItemSchema)),
  getFeatureFlagDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/feature-flags/{flagKey}',
      summary: 'Get flag config with targeting rules',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ flagKey: z.string() }) }))
    .output(FeatureFlagDetailSchema),
  updateFeatureFlag: terraContract
    .meta({ permissions: [...COCKPIT_FEATURE_FLAG_WRITE_PERMISSIONS] })
    .route({
      method: 'PUT',
      path: '/feature-flags/{flagKey}',
      summary: 'Update flag default value and/or targeting rules',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ flagKey: z.string() }),
        body: UpdateFeatureFlagBodySchema,
      }),
    )
    .output(FeatureFlagDetailSchema),
  deleteFeatureFlagRule: terraContract
    .meta({ permissions: [...COCKPIT_FEATURE_FLAG_WRITE_PERMISSIONS] })
    .route({
      method: 'DELETE',
      path: '/feature-flags/{flagKey}/rules/{ruleId}',
      summary: 'Delete a single targeting rule from a flag',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ flagKey: z.string(), ruleId: z.string() }),
      }),
    )
    .output(FeatureFlagDetailSchema),
  ...cockpitSystemRoutes,
  ...cockpitMisconfigResearchRoutes,
  ...cockpitValidationHubRoutes,
  ...cockpitTenantModelRouterRoutes,
  ...cockpitAiAccountRoutes,
  ...cockpitBillingRoutes,
  abortExecution: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/executions/abort',
      summary: 'Abort a running execution by thread ID',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        body: z.object({
          threadId: z.string(),
          applicationId: z.string(),
        }),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
        message: z.string(),
      }),
    ),
  abortAllRunningExecutions: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/executions/abort-all',
      summary:
        'Abort all running executions, optionally filtered by tenant, application, agent, or created-at range',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        body: z.object({
          tenantId: z.string().optional(),
          applicationId: z.string().optional(),
          agentName: z.string().optional(),
          from: z.string().datetime().optional(),
          to: z.string().datetime().optional(),
        }),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
        abortedCount: z.number().int().nonnegative(),
        failedCount: z.number().int().nonnegative(),
        message: z.string(),
      }),
    ),
  getSignalAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/signals',
      summary:
        'Platform-wide signal analytics with breakdowns by stage, status, category, origin',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AnalyticsQuerySchema }))
    .output(SignalAnalyticsSchema),
  getFindingAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/findings',
      summary:
        'Platform-wide finding analytics with breakdowns by severity, status, category',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FindingsAnalyticsQuerySchema }))
    .output(FindingAnalyticsSchema),
  getExecutionAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/executions',
      summary:
        'Platform-wide execution analytics with breakdowns by status, agent, duration',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AnalyticsQuerySchema }))
    .output(ExecutionAnalyticsSchema),
  getAutoPublishedFindingOutcomes: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/auto-published-finding-outcomes',
      summary: 'Auto-published finding outcomes by vulnerability category',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AutoPublishedFindingOutcomesQuerySchema }))
    .output(AutoPublishedFindingOutcomesSchema),
  getAutoFpRate: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/auto-fp-rate',
      summary:
        'Auto false-positive rate for post-attack vulnerability verdicts (DISPROVEN_VULNERABILITY signals and published findings marked FalsePositive vs other published findings)',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AutoFpRateQuerySchema }))
    .output(AutoFpRateSchema),
  getAutoFpRateSignals: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/auto-fp-rate/signals',
      summary:
        'Signal-level rows for auto FP rate export (true_positive or false_positive only; same filters as auto-fp-rate). Use fullExport to return up to 10k rows in one response (aligned with the auto-FP trace evaluation cap; total reflects all matches; compare against items.length to detect truncation); otherwise paginated.',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AutoFpRateSignalsQuerySchema }))
    .output(AutoFpSignalRowsPageSchema),
  getSignalPrecision: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/signal-precision',
      summary:
        'Signal precision (TP / (TP + FP)) over completed neo-post-attack executions in the run-time range. Published findings marked FalsePositive are excluded; FP is Confirmed→Disproven or Potential→Disproven with S3 isFalsePositive; TP is Neo Confirmed/Suspected plus a published non-FP finding. Broken down by tenant, category, confidence, weekly/monthly run-time cohorts, and a daily category timeline of decisive signals.',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: SignalPrecisionQuerySchema }))
    .output(SignalPrecisionSchema),
  getSignalPrecisionSignals: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/signal-precision/signals',
      summary:
        'Signal-level rows for precision-dashboard TP/FP export. Population is completed neo-post-attack traces in the selected execution run-time range. Use fullExport to return up to 10k rows.',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: SignalPrecisionSignalsQuerySchema }))
    .output(AutoFpSignalRowsPageSchema),
  getMatchedRuleAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/analytics/matched-rule-ids',
      summary:
        'Per matched-rule true/false-positive breakdown for post-attack verdicts',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: MatchedRuleAnalyticsQuerySchema }))
    .output(MatchedRuleAnalyticsSchema),
  getGitOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/git',
      summary:
        'Git integration overview with connection health, repos, and PR metrics',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: GitQuerySchema }))
    .output(GitOverviewSchema),
  getTechnologyUsage: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/git/technologies',
      summary:
        'Most used technologies and versions by distinct application count',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: TechnologyUsageQuerySchema }))
    .output(TechnologyUsageSchema),
  getBusinessContextCapabilityOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/business-context/applications',
      summary:
        'Cross-tenant overview of business context capability coverage per application',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: BusinessContextCapabilityOverviewQuerySchema }))
    .output(BusinessContextCapabilityOverviewSchema),
  getBusinessContextCapabilityDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/business-context/applications/{applicationId}',
      summary:
        'Capability questions, summaries, and full answers for one application',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ applicationId: z.string() }) }))
    .output(BusinessContextCapabilityDetailSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  getTenantAttackSurfaceFunnel: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/attack-surface-funnel',
      summary: 'Get attack surface changes funnel metrics for a tenant',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(AttackSurfaceFunnelSchema),
  getAppAttackSurfaceFunnel: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/applications/{applicationId}/attack-surface-funnel',
      summary: 'Get attack surface changes funnel metrics for an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string(), applicationId: z.string() }),
      }),
    )
    .output(AttackSurfaceFunnelSchema),
  setGitIntegrationDisabled: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'PATCH',
      path: '/git/integrations/{id}/disabled',
      summary: 'Set disabled state for a tenant git integration',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ id: z.string() }),
        body: z.object({ isDisabled: z.boolean().nullish() }),
      }),
    )
    .output(z.object({ success: z.boolean() })),
  getCrawlerOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/crawler',
      summary: 'Crawler sessions across all tenants with stats and filtering',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CrawlerQuerySchema }))
    .output(CrawlerOverviewSchema),
  triggerCrawler: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/crawler/trigger',
      summary: 'Trigger a crawler run for an application',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerCrawlerRequestSchema }))
    .output(TriggerCrawlerResponseSchema),
  ...cockpitEvaluationRoutes,
  ...cockpitSqlWorksheetRoutes,
  ...cockpitMemoryRoutes,
  listCoPilotEvalScenarios: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/scenarios',
      summary: 'List Co-Pilot eval scenarios',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        query: z.object({
          category: z.string().optional(),
          isActive: z.coerce.boolean().optional(),
          search: z.string().optional(),
          limit: z.coerce.number().min(1).max(200).optional(),
          offset: z.coerce.number().min(0).optional(),
        }),
      }),
    )
    .output(
      z.object({
        items: z.array(CoPilotEvalScenarioSchema),
        total: z.number(),
      }),
    ),
  createCoPilotEvalScenario: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/scenarios',
      summary: 'Create Co-Pilot eval scenario',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: CreateCoPilotEvalScenarioBodySchema }))
    .output(CoPilotEvalScenarioSchema),
  importCoPilotEvalScenarios: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/scenarios/import',
      summary: 'Import Co-Pilot eval scenarios from CSV rows',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ImportCoPilotEvalScenariosBodySchema }))
    .output(ImportCoPilotEvalScenariosResultSchema),
  draftCoPilotEvalScenario: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/scenarios/draft',
      summary: 'Draft a Co-Pilot eval scenario with AI',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: DraftCoPilotEvalScenarioBodySchema }))
    .output(CoPilotEvalScenarioDraftSchema),
  parseCoPilotEvalScenariosCsv: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/scenarios/parse-csv',
      summary: 'Parse Co-Pilot eval scenarios from CSV with AI',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ParseCoPilotEvalScenariosCsvBodySchema }))
    .output(ParseCoPilotEvalScenariosCsvResultSchema),
  importCoPilotEvalScenariosFromDrafts: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/scenarios/import-drafts',
      summary: 'Import Co-Pilot eval scenarios from AI drafts',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ImportCoPilotEvalScenariosFromDraftsBodySchema }))
    .output(ImportCoPilotEvalScenariosResultSchema),
  updateCoPilotEvalScenario: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'PUT',
      path: '/co-pilot/evaluations/scenarios/{scenarioId}',
      summary: 'Update Co-Pilot eval scenario',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ scenarioId: z.string() }),
        body: CreateCoPilotEvalScenarioBodySchema.partial(),
      }),
    )
    .output(CoPilotEvalScenarioSchema),
  deleteCoPilotEvalScenario: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'DELETE',
      path: '/co-pilot/evaluations/scenarios/{scenarioId}',
      summary: 'Soft-delete Co-Pilot eval scenario',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ scenarioId: z.string() }),
        body: z.object({}).optional(),
      }),
    )
    .output(CoPilotEvalScenarioSchema),
  triggerCoPilotEvalRun: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/runs/trigger',
      summary: 'Trigger Co-Pilot eval run',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerCoPilotEvalRunBodySchema }))
    .output(CoPilotEvalRunSchema),
  bulkTriggerCoPilotEvalRun: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/runs/bulk-trigger',
      summary: 'Trigger Co-Pilot eval run across all model presets',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: BulkTriggerCoPilotEvalRunBodySchema }))
    .output(z.object({ runs: z.array(CoPilotEvalRunSchema) })),
  batchTriggerCoPilotEvalRun: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/runs/batch-trigger',
      summary: 'Trigger N Co-Pilot eval runs with one model',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: BatchTriggerCoPilotEvalRunBodySchema }))
    .output(
      z.object({
        batchId: z.string(),
        experimentId: z.string(),
        runs: z.array(CoPilotEvalRunSchema),
      }),
    ),
  listCoPilotEvalRuns: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/runs',
      summary: 'List Co-Pilot eval runs',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        query: z.object({
          scenarioId: z.string().optional(),
          status: z.string().optional(),
          modelUsed: z.string().optional(),
          verdict: z.string().optional(),
          batchId: z.string().optional(),
          experimentId: z.string().optional(),
          experimentGroupId: z.string().optional(),
          experimentIds: z.string().optional(),
          datasetExperimentId: z.string().optional(),
          fromDatasetExperimentsOnly: z.coerce.boolean().optional(),
          from: z.iso.datetime().optional(),
          to: z.iso.datetime().optional(),
          limit: z.coerce.number().min(1).max(2000).optional(),
          offset: z.coerce.number().min(0).optional(),
        }),
      }),
    )
    .output(
      z.object({
        items: z.array(CoPilotEvalRunSchema),
        total: z.number(),
      }),
    ),
  getCoPilotEvalRun: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/runs/{runId}',
      summary: 'Get Co-Pilot eval run detail',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ runId: z.string() }) }))
    .output(CoPilotEvalRunSchema),
  getCoPilotEvalRunTranscript: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/runs/{runId}/transcript',
      summary: 'Get Co-Pilot eval run transcript',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ runId: z.string() }) }))
    .output(
      z.object({
        transcript: z.unknown().nullable(),
        downloadUrl: z.string().optional(),
      }),
    ),
  getCoPilotEvalDashboard: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/dashboard',
      summary: 'Co-Pilot eval dashboard stats',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        query: z.object({
          scenarioId: z.string().optional(),
        }),
      }),
    )
    .output(CoPilotEvalDashboardSchema),
  getCoPilotEvalScenarioStats: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/scenarios/{scenarioId}/stats',
      summary: 'Co-Pilot eval scenario aggregate stats',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ scenarioId: z.string() }) }))
    .output(CoPilotEvalScenarioStatsSchema),
  getCoPilotEvalBatchStats: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/batches/{batchId}/stats',
      summary: 'Co-Pilot eval batch aggregate stats',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ batchId: z.string() }) }))
    .output(CoPilotEvalBatchStatsSchema),
  createCoPilotEvalExperiment: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/experiments',
      summary: 'Create a Co-Pilot eval experiment',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: CreateCoPilotEvalExperimentBodySchema }))
    .output(
      z.object({
        experimentId: z.string(),
        experiment: CoPilotEvalExperimentSchema,
        runs: z.array(CoPilotEvalRunSchema),
      }),
    ),
  listCoPilotEvalExperiments: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/experiments',
      summary: 'List Co-Pilot eval experiments',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        query: z.object({
          scenarioId: z.string().optional(),
          limit: z.coerce.number().min(1).max(200).optional(),
          offset: z.coerce.number().min(0).optional(),
        }),
      }),
    )
    .output(
      z.object({
        items: z.array(CoPilotEvalExperimentSchema),
        total: z.number(),
      }),
    ),
  getCoPilotEvalExperimentStats: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/experiments/{experimentId}/stats',
      summary: 'Co-Pilot eval experiment aggregate stats',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ experimentId: z.string() }) }))
    .output(CoPilotEvalExperimentStatsSchema),
  exportCoPilotEvalRuns: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/runs/export',
      summary: 'Export Co-Pilot eval runs as CSV',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: ExportCoPilotEvalRunsQuerySchema }))
    .output(
      z.object({
        csv: z.string(),
        filename: z.string(),
      }),
    ),
  listCoPilotRunModels: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/models',
      summary: 'List Co-Pilot run model presets and eligible Terra models',
      inputStructure: 'detailed',
    })
    .output(CoPilotRunModelsSchema),
  resolveCoPilotAgentModels: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/models/resolve',
      summary:
        'Resolve Co-Pilot agent models for a run model and optional overrides',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ResolveCoPilotAgentModelsBodySchema }))
    .output(CoPilotAgentModelsConfigSchema),
  listCoPilotEvalDatasets: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/datasets',
      summary: 'List Co-Pilot eval datasets',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        query: z.object({
          limit: z.coerce.number().min(1).max(200).optional(),
          offset: z.coerce.number().min(0).optional(),
        }),
      }),
    )
    .output(
      z.object({
        items: z.array(CoPilotEvalDatasetSchema),
        total: z.number(),
      }),
    ),
  createCoPilotEvalDataset: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/datasets',
      summary: 'Create a Co-Pilot eval dataset',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: CreateCoPilotEvalDatasetBodySchema }))
    .output(CoPilotEvalDatasetSchema),
  getCoPilotEvalDataset: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/datasets/{datasetId}',
      summary: 'Get a Co-Pilot eval dataset',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ datasetId: z.string() }) }))
    .output(CoPilotEvalDatasetSchema),
  updateCoPilotEvalDataset: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'PUT',
      path: '/co-pilot/evaluations/datasets/{datasetId}',
      summary: 'Update a Co-Pilot eval dataset',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ datasetId: z.string() }),
        body: UpdateCoPilotEvalDatasetBodySchema,
      }),
    )
    .output(CoPilotEvalDatasetSchema),
  deleteCoPilotEvalDataset: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'DELETE',
      path: '/co-pilot/evaluations/datasets/{datasetId}',
      summary: 'Delete a Co-Pilot eval dataset',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ datasetId: z.string() }) }))
    .output(CoPilotEvalDatasetSchema),
  importCoPilotEvalDatasetCsv: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/datasets/import',
      summary: 'Import scenarios from CSV and create a dataset',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ImportCoPilotEvalDatasetCsvBodySchema }))
    .output(ImportCoPilotEvalDatasetCsvResultSchema),
  importCoPilotEvalDatasetCsvAi: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/datasets/import-ai',
      summary: 'Import scenarios from CSV with AI and create a dataset',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ImportCoPilotEvalDatasetCsvAiBodySchema }))
    .output(ImportCoPilotEvalDatasetCsvResultSchema),
  listCoPilotEvalDatasetExperiments: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/dataset-experiments',
      summary: 'List Co-Pilot eval dataset experiments',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        query: z.object({
          datasetId: z.string().optional(),
          limit: z.coerce.number().min(1).max(200).optional(),
          offset: z.coerce.number().min(0).optional(),
        }),
      }),
    )
    .output(
      z.object({
        items: z.array(CoPilotEvalDatasetExperimentSchema),
        total: z.number(),
      }),
    ),
  createCoPilotEvalDatasetExperiment: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/dataset-experiments',
      summary: 'Run a dataset experiment across all scenarios',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: CreateCoPilotEvalDatasetExperimentBodySchema }))
    .output(
      z.object({
        datasetExperimentId: z.string(),
        datasetExperiment: CoPilotEvalDatasetExperimentSchema,
        experiments: z.array(CoPilotEvalExperimentSchema),
        runs: z.array(CoPilotEvalRunSchema),
      }),
    ),
  getCoPilotEvalDatasetExperimentStats: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/dataset-experiments/{datasetExperimentId}/stats',
      summary: 'Aggregate stats for a dataset experiment',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ datasetExperimentId: z.string() }) }))
    .output(CoPilotEvalDatasetExperimentStatsSchema),
  getCoPilotEvalDatasetExperimentDetail: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/dataset-experiments/{datasetExperimentId}',
      summary: 'Full relevant data bundle for a dataset experiment',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ datasetExperimentId: z.string() }) }))
    .output(CoPilotEvalDatasetExperimentDetailSchema),
  getCoPilotEvalDatasetExperimentMetaAnalysis: terraContract
    .meta({ permissions: ['Evaluation Read'] })
    .route({
      method: 'GET',
      path: '/co-pilot/evaluations/dataset-experiments/{datasetExperimentId}/meta-analysis',
      summary: 'Cached meta-analysis for a dataset experiment',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ datasetExperimentId: z.string() }) }))
    .output(CoPilotEvalDatasetExperimentMetaAnalysisResponseSchema),
  generateCoPilotEvalDatasetExperimentMetaAnalysis: terraContract
    .meta({ permissions: ['Evaluation Execute'] })
    .route({
      method: 'POST',
      path: '/co-pilot/evaluations/dataset-experiments/{datasetExperimentId}/meta-analysis',
      summary: 'Generate or refresh meta-analysis for a dataset experiment',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ datasetExperimentId: z.string() }),
        body: z.object({}).optional(),
      }),
    )
    .output(CoPilotEvalDatasetExperimentMetaAnalysisGenerateResponseSchema)
    .errors({
      CONFLICT: { status: 409, data: z.object({ message: z.string() }) },
    }),
  getEndpointHealth: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/endpoints/health',
      summary:
        'Endpoint code-graph coverage per application with health breakdown',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: EndpointHealthQuerySchema }))
    .output(EndpointHealthOverviewSchema),
  getEndpointSourceCoverage: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/endpoints/source-coverage',
      summary:
        'Endpoint discovery source coverage with totals and unique-only counts',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: EndpointSourceCoverageQuerySchema }))
    .output(EndpointSourceCoverageOverviewSchema),
  getEndpointsMissingCodeGraph: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/endpoints/missing-code-graph',
      summary: 'List endpoints without a code graph for a given application',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: EndpointMissingCodeGraphQuerySchema }))
    .output(EndpointMissingCodeGraphListSchema),
  triggerCodeGraph: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/trigger-code-graph',
      summary: 'Trigger code graph generation for a specific endpoint',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerCodeGraphRequestSchema }))
    .output(EndpointActionResponseSchema),
  triggerMissingCodeGraphs: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/trigger-code-graph-missing',
      summary:
        'Trigger code graph generation for all endpoints missing code graphs',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerMissingCodeGraphsRequestSchema }))
    .output(EndpointActionResponseSchema),
  triggerCodeGraphBulk: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/trigger-code-graph-bulk',
      summary: 'Trigger code graph generation for a list of endpoint IDs',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerCodeGraphBulkRequestSchema }))
    .output(EndpointActionResponseSchema),
  resetFailedGraphs: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/reset-failed-graphs',
      summary:
        'Reset all failed code-graph endpoints for an application so the scheduler retries them',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ResetFailedGraphsRequestSchema }))
    .output(EndpointActionResponseSchema),
  triggerStupidSignalsBulk: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/trigger-stupid-signals-bulk',
      summary:
        'Trigger stupid signal generation for selected endpoints without code graph',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerStupidSignalsRequestSchema }))
    .output(EndpointActionResponseSchema),
  triggerSmartSignalsBulk: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/trigger-smart-signals-bulk',
      summary:
        'Trigger smart signal generation for selected endpoints with code graph',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerSmartSignalsRequestSchema }))
    .output(SmartSignalActionResponseSchema),
  triggerAiSignalGeneration: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/ai-applications/trigger-signal-generation',
      summary:
        'Trigger AI application signal generation (AI_SIGNAL_GEN_REQUEST)',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerAiSignalGenerationRequestSchema }))
    .output(EndpointActionResponseSchema),
  triggerDeepActiveProbeAll: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/trigger-deep-active-probe-all',
      summary:
        'Queue Deep active probe research for every in-scope endpoint of an application',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: TriggerDeepActiveProbeAllRequestSchema }))
    .output(TriggerDeepActiveProbeAllResponseSchema),
  getDeepActiveProbePause: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/endpoints/deep-active-probe/pause',
      summary: 'Get whether Deep active probe processing is paused',
      inputStructure: 'detailed',
    })
    .output(DeepActiveProbePauseStatusSchema),
  setDeepActiveProbePause: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'PUT',
      path: '/endpoints/deep-active-probe/pause',
      summary:
        'Pause or resume Deep active probe processing; while paused, queued research requests are skipped',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: SetDeepActiveProbePauseRequestSchema }))
    .output(DeepActiveProbePauseStatusSchema),
  getAllEndpoints: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/endpoints/all',
      summary: 'Get all endpoints for an application with code graph status',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AllEndpointsQuerySchema }))
    .output(AllEndpointsResponseSchema),
  startEndpointBulkRun: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/bulk-runs',
      summary: 'Start a resumable endpoint operation run',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: StartEndpointBulkRunRequestSchema }))
    .output(EndpointBulkRunSchema),
  getActiveEndpointBulkRun: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/endpoints/active-bulk-run',
      summary: 'Get the active endpoint operation run',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: ActiveEndpointBulkRunQuerySchema }))
    .output(ActiveEndpointBulkRunResponseSchema),
  getEndpointBulkRun: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/endpoints/bulk-runs/{runId}',
      summary: 'Get endpoint operation run progress',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: EndpointBulkRunParamsSchema }))
    .output(EndpointBulkRunSchema),
  continueEndpointBulkRun: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/bulk-runs/{runId}/continue',
      summary: 'Continue pending and failed endpoint operation items',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: EndpointBulkRunParamsSchema }))
    .output(EndpointBulkRunSchema),
  dismissEndpointBulkRun: terraContract
    .meta({ permissions: [...COCKPIT_ENDPOINT_OPS_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/endpoints/bulk-runs/{runId}/dismiss',
      summary: 'Dismiss an endpoint operation run and unlock further actions',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: EndpointBulkRunParamsSchema }))
    .output(DismissEndpointBulkRunResponseSchema),
  startApplicationDuplicationJob: terraContract
    .meta({ permissions: [...COCKPIT_APP_DUPLICATOR_PERMISSIONS] })
    .route({
      method: 'POST',
      path: '/applications/duplication/jobs',
      summary:
        'Start an application duplication job using a pasted JIT Mongo URI',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: StartApplicationDuplicationJobRequestSchema }))
    .output(StartApplicationDuplicationJobResponseSchema),
  getApplicationDuplicationJob: terraContract
    .meta({ permissions: [...COCKPIT_APP_DUPLICATOR_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/applications/duplication/jobs/{jobId}',
      summary: 'Get application duplication job progress',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationDuplicationJobParamsSchema }))
    .output(ApplicationDuplicationJobSchema),
  deduplicateSignalsBulk: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/endpoints/deduplicate-signals-bulk',
      summary:
        'Retroactively deduplicate existing signals for an application using tiered dedup',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: DeduplicateSignalsBulkRequestSchema }))
    .output(DeduplicateSignalsBulkResponseSchema),
  getCostOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/costs',
      summary: 'Get cost overview with breakdowns and trend',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CostQuerySchema }))
    .output(CostOverviewSchema),
  getCostLicenseTypeOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/costs/license-types',
      summary: 'Get cost totals grouped by license type',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CostQuerySchema }))
    .output(CostLicenseTypeOverviewSchema),
  getCostBreakdown: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/costs/breakdown',
      summary: 'Get cost breakdown by specified dimension',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CostQuerySchema }))
    .output(z.array(CostBreakdownItemSchema)),
  getCostByThread: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/costs/threads',
      summary: 'Get cost breakdown per execution thread',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CostByThreadQuerySchema }))
    .output(
      z.object({
        threads: z.array(CostThreadSummarySchema),
        total: z.number(),
      }),
    ),
  getCostFlowSankey: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/costs/flow-sankey',
      summary:
        'Get Sankey summary flow from total cost through surfaces, categories, and root operations',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CostQuerySchema }))
    .output(CostFlowSankeySchema),
  getCostByApplicationCategory: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/costs/by-application',
      summary:
        'Get cost per application split into Sankey categories (Discovery, Signals, Executions, Co-pilot, Other)',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CostQuerySchema }))
    .output(CostByApplicationCategorySchema),
  getAiCacheOverview: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/ai-cache/overview',
      summary:
        'Get provider prompt-cache hit rate, spend, savings, and anomalies across AI services',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: AiCacheQuerySchema }))
    .output(AiCacheOverviewSchema),
  getMe: terraContract
    .meta({ authenticated: true })
    .route({
      method: 'GET',
      path: '/me',
      summary: 'Get current user info including resolved roles and permissions',
      inputStructure: 'detailed',
    })
    .output(
      z.object({
        userId: z.string(),
        roles: z.array(z.string()),
        permissions: z.array(z.string()),
      }),
    ),
  getAuditLogs: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'GET',
      path: '/audit-logs',
      summary: 'Get cockpit action audit logs',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CockpitAuditLogsQuerySchema }))
    .output(CockpitAuditLogsResponseSchema),
  getAuditLogFilters: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'GET',
      path: '/audit-logs/filters',
      summary: 'Get distinct cockpit audit log action and actor filters',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CockpitAuditLogFiltersQuerySchema }))
    .output(CockpitAuditLogFiltersResponseSchema),
  getUsers: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'GET',
      path: '/users',
      summary: 'Get cockpit users with roles and permissions',
      inputStructure: 'detailed',
    })
    .output(CockpitUsersResponseSchema),
  getK8sOperators: terraContract
    .meta({
      permissions: ['K8S Operators Read'],
    })
    .route({
      method: 'GET',
      path: '/k8s-operators',
      summary: 'List customer K8S operators',
      inputStructure: 'detailed',
    })
    .output(K8sOperatorsResponseSchema),
  createK8sOperator: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators',
      summary: 'Create a customer K8S operator and issue access key',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: CreateK8sOperatorBodySchema }))
    .output(CreateK8sOperatorResponseSchema),
  rotateK8sOperatorAccessKey: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/rotate-access-key',
      summary: 'Rotate K8S operator access key',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
      }),
    )
    .output(RotateK8sOperatorAccessKeyResponseSchema),
  getK8sOperatorById: terraContract
    .meta({
      permissions: ['K8S Operators Read'],
    })
    .route({
      method: 'GET',
      path: '/k8s-operators/{operatorId}',
      summary: 'Get K8S operator details',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
      }),
    )
    .output(K8sOperatorDetailResponseSchema),
  deleteK8sOperator: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'DELETE',
      path: '/k8s-operators/{operatorId}',
      summary: 'Delete K8S operator',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
      }),
    )
    .output(DeleteK8sOperatorResponseSchema),
  publishK8sOperatorMessage: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/publish',
      summary: 'Publish a message to K8S operator commands queue',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        body: PublishK8sOperatorMessageBodySchema,
      }),
    )
    .output(PublishK8sOperatorMessageResponseSchema),
  publishK8sOperatorManifest: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/publish-manifest',
      summary: 'Upload operator manifest and publish manifest task message',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        body: PublishK8sOperatorManifestBodySchema,
      }),
    )
    .output(PublishK8sOperatorManifestResponseSchema),
  publishK8sOperatorKubectl: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/publish-kubectl',
      summary: 'Publish kubectl task message to K8S operator commands queue',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        body: PublishK8sOperatorKubectlBodySchema,
      }),
    )
    .output(PublishK8sOperatorKubectlResponseSchema),
  publishK8sOperatorHelmCommand: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/publish-helm-command',
      summary:
        'Publish helm command task message to K8S operator commands queue',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        body: PublishK8sOperatorHelmCommandBodySchema,
      }),
    )
    .output(PublishK8sOperatorHelmCommandResponseSchema),
  publishK8sOperatorHelmUpgrade: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/helm-releases/upgrade',
      summary: 'Publish helm upgrade task for an installed release',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        body: PublishK8sOperatorHelmUpgradeBodySchema,
      }),
    )
    .output(PublishK8sOperatorHelmCommandResponseSchema),
  getK8sOperatorActivity: terraContract
    .meta({
      permissions: ['K8S Operators Read'],
    })
    .route({
      method: 'GET',
      path: '/k8s-operators/{operatorId}/activity',
      summary: 'Get activity feed for a K8S operator',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
      }),
    )
    .output(GetK8sOperatorActivityResponseSchema),
  getK8sOperatorExecutions: terraContract
    .meta({
      permissions: ['K8S Operators Read'],
    })
    .route({
      method: 'GET',
      path: '/k8s-operators/{operatorId}/executions',
      summary: 'Get publish executions for a K8S operator',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
      }),
    )
    .output(GetK8sOperatorExecutionsResponseSchema),
  getK8sOperatorHelmReleases: terraContract
    .meta({
      permissions: ['K8S Operators Read'],
    })
    .route({
      method: 'GET',
      path: '/k8s-operators/{operatorId}/helm-releases',
      summary: 'Get Helm releases for a K8S operator',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        query: GetK8sOperatorHelmReleasesQuerySchema.optional(),
      }),
    )
    .output(GetK8sOperatorHelmReleasesResponseSchema),
  requestK8sOperatorHelmList: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/helm-releases/request',
      summary: 'Request operator Helm list for monitoring',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
        }),
        body: RequestK8sOperatorHelmListBodySchema.optional(),
      }),
    )
    .output(RequestK8sOperatorHelmListResponseSchema),
  updateK8sOperatorHelmRelease: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'PATCH',
      path: '/k8s-operators/{operatorId}/helm-releases/{releaseKey}',
      summary: 'Update Helm release config for a K8S operator',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
          releaseKey: z.string(),
        }),
        body: UpdateK8sOperatorHelmReleaseBodySchema,
      }),
    )
    .output(UpdateK8sOperatorHelmReleaseResponseSchema),
  publishK8sOperatorHelmRelease: terraContract
    .meta({
      permissions: ['K8S Operators Write'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/{operatorId}/helm-releases/{releaseKey}/publish',
      summary: 'Publish stored Helm release config to operator',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          operatorId: z.string(),
          releaseKey: z.string(),
        }),
        body: z.object({}).optional(),
      }),
    )
    .output(PublishK8sOperatorHelmReleaseResponseSchema),
  getLicenses: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/licenses',
      summary: 'List all tenant licenses',
      inputStructure: 'detailed',
    })
    .output(
      z.object({
        licenses: z.array(LicenseResponseSchema),
      }),
    ),
  getLicenseByTenant: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/licenses/{tenantId}',
      summary: 'Get license for a specific tenant',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ tenantId: z.string() }) }))
    .output(LicenseResponseSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  upsertLicense: terraContract
    .meta({ permissions: [...COCKPIT_LICENSE_WRITE_PERMISSIONS] })
    .route({
      method: 'PUT',
      path: '/licenses/{tenantId}',
      summary: 'Create or update a tenant license',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ tenantId: z.string() }),
        body: UpsertLicenseBodySchema,
      }),
    )
    .output(LicenseResponseSchema),
  getCoPilotSkills: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/skills',
      summary:
        'Co-Pilot skill catalog with parsed SKILL.md and agent tool lists',
      inputStructure: 'detailed',
    })
    .output(CoPilotSkillsCatalogSchema),
  getCoPilotCustomSkills: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/custom-skills',
      summary:
        'List tenant-scoped custom Co-Pilot skills created via the skill creator',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotCustomSkillsQuerySchema }))
    .output(CoPilotCustomSkillsResponseSchema),
  getCoPilotCustomSkill: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/custom-skills/{skillId}',
      summary: 'Get a custom Co-Pilot skill with draft and published versions',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          skillId: z.string(),
        }),
      }),
    )
    .output(CoPilotCustomSkillResponseSchema),
  getCopilotThreadFilesystem: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/tenants/{tenantId}/co-pilot/threads/{threadId}/filesystem',
      summary:
        'Read the redis-backed virtual filesystem of a co-pilot thread for a tenant',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          tenantId: z.string(),
          threadId: z.string(),
        }),
        query: CopilotThreadFilesystemQuerySchema,
      }),
    )
    .output(CopilotThreadFilesystemResponseSchema),
  getFpAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-positives/analytics',
      summary:
        'Neo false-positive analytics with breakdowns by category, severity, date, and tenant',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FpAnalyticsQuerySchema }))
    .output(FpAnalyticsSchema),
  getFpFeedbacks: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-positives/feedbacks',
      summary:
        'Paginated or full-export list of Neo false-positive tester feedback rows from S3',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FpFeedbackQuerySchema }))
    .output(FpFeedbackPageSchema),
  listFpReports: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-positives/reports',
      summary:
        'List available Neo false-positive daily/weekly highlight reports from S3',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FpReportListQuerySchema }))
    .output(FpReportsListSchema),
  getFpReport: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-positives/reports/content',
      summary:
        'Fetch the markdown content of a Neo false-positive highlight report',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FpReportQuerySchema }))
    .output(FpReportContentSchema),
  listFpRecommendationReports: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-positives/recommendations/reports',
      summary:
        'List available Neo false-positive recommendation reports from S3',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FpReportListQuerySchema }))
    .output(FpRecommendationReportsListSchema),
  getFpRecommendations: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-positives/recommendations/content',
      summary:
        'Fetch structured recommendations for a Neo false-positive report',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FpRecommendationsQuerySchema }))
    .output(FpRecommendationsContentSchema),
  getFnAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-negatives/analytics',
      summary:
        'Neo false-negative analytics for signals later confirmed or published after disproven',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FnAnalyticsQuerySchema }))
    .output(FnAnalyticsSchema),
  getFnRows: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/false-negatives/rows',
      summary:
        'Paginated Neo false-negative rows from signal audit and published findings',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: FnListQuerySchema }))
    .output(FnPageSchema),
  getPtLeaderboard: terraContract
    .meta({ permissions: [...PT_LEADERBOARD_READER_PERMISSIONS] })
    .route({
      method: 'GET',
      path: '/pt-leaderboard',
      summary:
        'Aggregated signal stage and status transitions per reviewer for PT coaching metrics',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: PtLeaderboardQuerySchema }))
    .output(PtLeaderboardResponseSchema),
  listContentFilters: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/content-filters',
      summary: 'List LLM content filter records across tenants',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: ContentFilterListQuerySchema }))
    .output(
      z.object({
        items: z.array(ContentFilterListItemSchema),
        total: z.number(),
        page: z.number(),
        pageSize: z.number(),
      }),
    ),
  getContentFilterAnalytics: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/content-filters/analytics',
      summary:
        'Content filter event counts over time and per tenant for cockpit charts',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: ContentFilterAnalyticsQuerySchema }))
    .output(ContentFilterAnalyticsSchema),
  getContentFilterDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/content-filters/{id}',
      summary: 'Get LLM content filter record detail including human messages',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ id: z.string() }) }))
    .output(ContentFilterDetailSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  getCoPilotVisibilitySummary: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/summary',
      summary: 'Co-Pilot visibility KPI summary',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityQuerySchema }))
    .output(CoPilotVisibilityKpiSchema),
  getCoPilotVisibilityCost: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/cost',
      summary: 'Co-Pilot cost breakdown and per-thread distribution',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityQuerySchema }))
    .output(CoPilotVisibilityCostSchema),
  getCoPilotVisibilityExpensiveTraces: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/expensive-traces',
      summary: 'Investigated expensive Co-Pilot threads',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityQuerySchema }))
    .output(z.array(CoPilotExpensiveTraceSchema)),
  getCoPilotVisibilityExpensiveTraceDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/expensive-traces/{threadId}',
      summary: 'Expensive Co-Pilot thread investigation detail',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ threadId: z.string() }),
        query: z.object({ tenantId: z.string().optional() }),
      }),
    )
    .output(CoPilotExpensiveTraceDetailSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  getCoPilotVisibilityFeedbackInvestigations: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/feedback-investigations',
      summary: 'Co-Pilot detailed feedback with investigation status',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotFeedbackInvestigationsQuerySchema }))
    .output(z.array(CoPilotFeedbackInvestigationRowSchema)),
  getCoPilotVisibilityFeedbackInvestigationDetail: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/feedback-investigations/{feedbackId}',
      summary: 'Co-Pilot feedback investigation detail',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: z.object({ feedbackId: z.string() }) }))
    .output(CoPilotFeedbackInvestigationDetailSchema)
    .errors({
      NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
    }),
  getCoPilotVisibilityErrors: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/errors',
      summary: 'Co-Pilot error rollups and root-cause samples',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityQuerySchema }))
    .output(CoPilotVisibilityErrorsSchema),
  getCoPilotVisibilityQueries: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/queries',
      summary: 'Co-Pilot user query classification insights',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityQuerySchema }))
    .output(CoPilotVisibilityQueriesSchema),
  getCoPilotVisibilityCategoryQueries: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/category-queries',
      summary: 'Co-Pilot user queries for a selected classification category',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityCategoryQueriesQuerySchema }))
    .output(CoPilotVisibilityCategoryQueriesSchema),
  getCoPilotVisibilityPerformance: terraContract
    .meta({ permissions: ['Cockpit Viewer'] })
    .route({
      method: 'GET',
      path: '/co-pilot/visibility/performance',
      summary: 'Co-Pilot performance, engagement, and reliability metrics',
      inputStructure: 'detailed',
    })
    .input(z.object({ query: CoPilotVisibilityQuerySchema }))
    .output(CoPilotVisibilityPerformanceSchema),
  ...cockpitPublicRoutes,
});
